<template>
  <div class="all">
    <div class="enterprisetop">
      <div style="float:left;height:100%;width:22%;border-right:1px solid #ccc;background: #F9FAFC;">
        <el-tooltip class="item"
                    effect="light"
                    content="中控技术股份有限公司"
                    placement="top">
          <div class="company">
            {{ dataForm.companyName }}
          </div>
        </el-tooltip>
        <div class="allcompany">
          <el-tooltip class="item"
                      effect="light"
                      content="项目1"
                      placement="top">
            <div>项目1</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="项目1"
                      placement="top">
            <div>项目1</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="项目1"
                      placement="top">
            <div>项目1</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="项目1"
                      placement="top">
            <div>项目1</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="项目项目1项目项目1"
                      placement="top">
            <div>项目项目1项目项目1</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="项目1"
                      placement="top">
            <div>项目1</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="项目1"
                      placement="top">
            <div>项目1</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="项目1"
                      placement="top">
            <div>项目1</div>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="light"
                      content="项目1"
                      placement="top">
            <div>项目1</div>
          </el-tooltip>
        </div>
      </div>
      <div class="secondtable">
        <div>企业编码</div>
        <div>{{ dataForm.companyCode }}</div>
        <div>企业主联系人</div>
        <div>{{ dataForm.contacts }}</div>
        <div>注册时间</div>
        <div>{{ dataForm.registerTime }}</div>
        <div>注册端</div>
        <div>{{dataForm.registClient}}</div>
        <div>注册渠道</div>
        <div>{{ dataForm.registChannel }}</div>
      </div>
      <div class="thirdtable">
        <div>账号类型</div>
        <div>{{ dataForm.companyType }}</div>
        <div>是否认证</div>
        <div>{{dataForm.authentFlag }} </div>
        <div>企业性质</div>
        <div>{{ dataForm.nature }}</div>
        <div>所属行业</div>
        <div>化工</div>
        <div>企业地址</div>
        <div>{{ dataForm.address }}</div>
      </div>
    </div>
    <div class="statistics">
      <div style="float:left">统计信息</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="statisticsTable"
              border
              style="width: 100%">
      <el-table-column prop="jine"
                       fixed
                       width="120"
                       label="消费金额">
      </el-table-column>
      <el-table-column prop="shuliang"
                       width="120"
                       label="订单数量">
      </el-table-column>
      <el-table-column prop="youhui"
                       width="120"
                       label="优惠券（张）">
      </el-table-column>
      <el-table-column prop="yufu"
                       width="120"
                       label="预付款">
      </el-table-column>
      <el-table-column prop="daifu"
                       width="120"
                       label="待付款">
      </el-table-column>
      <el-table-column prop="xinyong"
                       width="120"
                       label="信用度">
      </el-table-column>
      <el-table-column prop="pingjia"
                       min-width="120"
                       label="评价">
      </el-table-column>
      <el-table-column prop="guanlian"
                       width="120"
                       label="关联企业">
      </el-table-column>
    </el-table>
    <div class="collections">
      <div style="float:left">收款记录</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="collectionsTable"
              border
              style="width: 100%">
      <el-table-column prop="zhangdan"
                       fixed
                       label="账单号">
      </el-table-column>
      <el-table-column prop="leixing"
                       label="账单类型">
      </el-table-column>
      <el-table-column prop="riqi"
                       label="账单日期">
      </el-table-column>
      <el-table-column prop="yingfu"
                       label="应付款">
      </el-table-column>
      <el-table-column prop="yishou"
                       label="已收款">
      </el-table-column>
    </el-table>
    <div class="enquiry">
      <div style="float:left">询价单记录</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="enquiryTable"
              border
              style="width: 100%">
      <el-table-column prop="bianhao"
                       fixed
                       label="订单编号">
      </el-table-column>
      <el-table-column prop="tijiao"
                       label="提交时间">
      </el-table-column>
      <el-table-column prop="zhanghao"
                       label="用户账号">
      </el-table-column>
      <el-table-column prop="jine"
                       label="订单金额">
      </el-table-column>
      <el-table-column prop="zhifu"
                       label="支付方式">
      </el-table-column>
      <el-table-column prop="laiyuan"
                       label="订单来源">
      </el-table-column>
      <el-table-column prop="zhuangtai"
                       label="订单状态">
      </el-table-column>
      <el-table-column prop=""
                       label="操作">
        <template>
          <div>查看询价单</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="orderform">
      <div style="float:left">订单记录</div>
      <div style="float:right;cursor:pointer;color:blue">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <el-table :data="orderformTable"
              border
              style="width: 100%">
      <el-table-column prop="bianhao"
                       fixed
                       label="订单编号">
      </el-table-column>
      <el-table-column prop="tijiao"
                       label="提交时间">
      </el-table-column>
      <el-table-column prop="zhanghao"
                       label="用户账号">
      </el-table-column>
      <el-table-column prop="jine"
                       label="订单金额">
      </el-table-column>
      <el-table-column prop="zhifu"
                       label="支付方式">
      </el-table-column>
      <el-table-column prop="laiyuan"
                       label="订单来源">
      </el-table-column>
      <el-table-column prop="zhuangtai"
                       label="订单状态">
      </el-table-column>
      <el-table-column prop=""
                       label="操作">
        <template>
          <div>查看订单</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        companyName: '中控技术股份有限公司', // 公司名称
        companyCode: 'CU20200923001', // 企业编码
        contacts: '王小二', // 企业主联系人
        registerTime: '2017-07-24 17:25:38', // 注册时间
        registClient: 'PC端', // 注册端
        registChannel: '手机号注册（微信/QQ/OneLogin/Apple）', // 注册渠道
        companyType: '企业账号',
        authentFlag: '已认证 ：企业客户、渠道商', // 是否认证
        nature: '国有企业', // 企业性质
        address: '浙江省绍兴市环城东路209号'
      },
      // 统计信息
      statisticsTable: [
        {
          jine: 1000,
          shuliang: 100,
          youhui: 20,
          yufu: 30000,
          daifu: 70000,
          xinyong: '90%',
          pingjia: '真的是太好了，无敌了',
          guanlian: 20
        }
      ],
      // 收款记录
      collectionsTable: [
        {
          zhangdan: 'D20200923000120',
          leixing: '工程服务单',
          riqi: '2020-09-23 13:23:24',
          yingfu: '¥25010.00',
          yishou: '¥2500.00'
        },
        {
          zhangdan: 'D20200923000120',
          leixing: '工程服务单',
          riqi: '2020-09-23 13:23:24',
          yingfu: '¥2500.00',
          yishou: '¥2500.00'
        },
        {
          zhangdan: 'D202300923000120',
          leixing: '工程服务单',
          riqi: '2020-09-23 13:23:24',
          yingfu: '¥2500.00',
          yishou: '¥2500.00'
        },
        {
          zhangdan: 'D201200923000120',
          leixing: '工程服务单',
          riqi: '2020-09-23 13:23:24',
          yingfu: '¥2500.00',
          yishou: '¥2500.00'
        }
      ],
      // 询价列表
      enquiryTable: [
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2019-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2018-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '支付宝', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥2000.00', // 订单金额
          zhifu: '微信', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        }
      ],
      // 订单列表
      orderformTable: [
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2019-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '未支付', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2018-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥200.00', // 订单金额
          zhifu: '支付宝', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        },
        {
          bianhao: '201707196398345', // 编号
          tijiao: '2017-07-19 14:48:38', // 提交时间
          zhanghao: '18000000000', // 用户账号
          jine: '¥2000.00', // 订单金额
          zhifu: '微信', // 支付方式
          laiyuan: 'APP订单', // 订单来源
          zhuangtai: '未报价' // 订单状态
        }
      ]
    }
  },
  methods: {

  },
  components: {
  }
}
</script>
<style lang="scss" scoped="scoped">
.enterprisetop {
  width: 100%;
  height: 201px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.company {
  height: 30px;
  width: 70%;
  text-align: center;
  line-height: 30px;
  margin-left: 15%;
  margin-top: 25px;
  padding-right: 10px;
  padding-left: 10px;
  border: 1px solid red;
  background: red;
  color: white;
  border-radius: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.allcompany {
  height: 140px;
  width: 100%;
  margin-top: 15px;
}
.allcompany div {
  width: 30%;
  margin-left: 3%;
  height: 32px;
  margin-top: 8px;
  line-height: 37px;
  border-radius: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #e9e9e9;
  text-align: center;
  float: left;
  font-size: 12px;
  padding-right: 5px;
  padding-left: 5px;
}
.secondtable,
.thirdtable {
  float: left;
  width: 39%;
  height: 100%;
}
.secondtable div:nth-of-type(odd) {
  width: 30%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: #f9fafc;
}
.secondtable div:nth-of-type(even) {
  width: 70%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding-left: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.thirdtable div:nth-of-type(odd) {
  width: 30%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: #f9fafc;
}
.thirdtable div:nth-of-type(even) {
  width: 70%;
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding-left: 10px;
  font-size: 12px;
  border-bottom: 1px solid #ccc;
}
.statistics,
.collections,
.enquiry,
.orderform {
  width: 100%;
  height: 35px;
  line-height: 35px;
}
</style>
